module.exports = __webpack_public_path__ + "static/media/buildingConstruction33.132bd3cc.jpg";